export default "__VITE_ASSET__Cf$022Qx__"